import { lightAssets } from './assets';
// TODO: minimalChatTokens

export const lightTheme = {
	id: 'light',
	assets: lightAssets,
};
